module.exports = {
  GA_TRACKING_ID: "G-C1LVZ2DJDN",
  HEAP_TRACKING_ID: "3792777015",
  HOTJAR_TRACKING_ID: 2948625,
  HOTJAR_VERSION_ID: 6,
  API_BASE_URL: "http://localhost:3000",
};
